const setSelectedSession = (state, payload) => {
  state.selectedSession = payload
}

const setIsRenderedReport = (state, payload) => {
  state.isRenderedReport = payload
}

const setIsCreatingNewSession = (state, payload) => {
  state.isCreatingNewSession = payload
}

export default {
  setSelectedSession,
  setIsRenderedReport,
  setIsCreatingNewSession,
}
